import script from "./ProcessReviewPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessReviewPanel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__